import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustry } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippIndustrySlice = new RestSlice<IppIndustry>(
	localizationService.getLocalizedString('ipp.industries.industryPageHeading'),
	Resource.IppIndustries
);
export default ippIndustrySlice.rests.reducer;
